import { apiRequest } from './client';
import type { DeveloperUpsertRequest, DeveloperView } from './types';

export const developers = {
  list: (organizationId: string) =>
    apiRequest<DeveloperView[]>('/api/developers', { organizationId }),

  get: (organizationId: string, login: string) =>
    apiRequest<DeveloperView>(`/api/developers/${encodeURIComponent(login)}`, { organizationId }),

  upsert: (organizationId: string, login: string, body: DeveloperUpsertRequest) =>
    apiRequest<DeveloperView>(`/api/developers/${encodeURIComponent(login)}`, {
      method: 'PUT',
      organizationId,
      body,
    }),

  delete: (organizationId: string, login: string) =>
    apiRequest<void>(`/api/developers/${encodeURIComponent(login)}`, {
      method: 'DELETE',
      organizationId,
    }),
};
